export const workOrderStatusLabels = {
  pending: '待调理',
  in_progress: '进行中',
  completed: '已完成',
  cancelled: '已取消'
};

export const treatmentRecordStatusLabels = {
  draft: '草稿',
  submitted: '已提交',
  archived: '已归档',
  invalid: '作废'
};

export const appointmentStatusLabels = {
  pending: '待确认',
  scheduled: '已排期',
  confirmed: '已确认',
  cancelled: '已取消',
  completed: '已完成',
  noshow: '未到场',
  rescheduled: '已改期',
  in_progress: '进行中',
  archived: '已归档'
}; 